export const HTTP_SUCCESS_CODE = '000000'

export enum ERROR_HTTP_CODE {
  /**
   * 550004-登录token已经失效
   */
  TOKEN_ERROR = '550004',
  /**
   * EX_ACCESSTOKEN_EMPTY("551004", "accessToken为空"), （聚合层返回）
   */
  EX_ACCESSTOKEN_EMPTY = '551004',
  /**
   * REPEAT_LOGIN("607501", "账户已经在其他地方登录，请重新登录")
   */
  REPEAT_LOGIN = '607501',
  /**
   * EX_REFRESHTOKEN_INVALID("551011", "refreshToken已经失效"), （聚合层返回）
   */
  EX_REFRESHTOKEN_INVALID = '551011',
  /**
   * TEMPORARY_ERROR("570062", "refreshToken已经失效"), （网关返回）
   */
  TEMPORARY_ERROR = '570062',
  /**
   * EX_ACCESSTOKEN_EMPTY("607124", "accessToken为空"), （网关返回）
   */
  EX_ACCESSTOKEN_EMPTY_GATEWAY = '607124',
}
